import { useState, useEffect } from 'react';

function useViewport() {
    const [isMobile, setIsMobile] = useState(false);
    const [isDesktop, setIsDesktop] = useState(true);

    useEffect(() => {
        const handleResize = () => {
            const mobile = window.innerWidth < 700;
            setIsMobile(mobile);
            setIsDesktop(!mobile);
        };

        window.addEventListener('resize', handleResize);
        handleResize();

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return { isMobile, isDesktop };
}

export default useViewport;
